const generateFilterQueryParams = (appliedFilters) => appliedFilters.reduce((acc, curr) => ({ ...acc, [curr.name]: curr.options.join(',') }), {});
const prepopulateFilterFromDefaultValues = (filters) => {
    const filtersWithDefaultValue = (filters || []).filter((filter) => filter === null || filter === void 0 ? void 0 : filter.defaultValue);
    return filtersWithDefaultValue.length !== 0
        ? filtersWithDefaultValue.reduce((acc, curr) => ({ ...acc, [curr.name]: curr.defaultValue }), {})
        : {};
};
const prepopulateMultiSelectFilterFromDefaultValues = (filters) => {
    const matchingOptions = {};
    filters.forEach((filter) => {
        const defaultValue = filter.defaultValue;
        if (!defaultValue) {
            return;
        }
        const options = filter.options;
        const optionsMatch = options.filter((option) => defaultValue.includes(option.value));
        if (optionsMatch.length > 0) {
            matchingOptions[filter.name] = optionsMatch;
        }
    });
    return matchingOptions;
};
const prepopulateMultiSelectFilterValuesFromSearchParams = (filters, searchParamsObj) => {
    const matchingOptions = {};
    filters.forEach((filter) => {
        const matchingOption = filter.options.filter((option) => ((searchParamsObj === null || searchParamsObj === void 0 ? void 0 : searchParamsObj[filter.name]) || []).includes(option.value));
        if (matchingOption.length > 0) {
            matchingOptions[filter.name] = matchingOption;
        }
    });
    return matchingOptions;
};
const filterBgImgUrl = (bgUrl) => ((bgUrl === null || bgUrl === void 0 ? void 0 : bgUrl.startsWith('~')) ? bgUrl.substring(1) : bgUrl);
export { generateFilterQueryParams, prepopulateFilterFromDefaultValues, filterBgImgUrl, prepopulateMultiSelectFilterValuesFromSearchParams, prepopulateMultiSelectFilterFromDefaultValues };
